"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sellQuantityClicked = exports.sellPriceClicked = exports.quantityClicked = exports.priceClicked = exports.buyQuantityClicked = exports.buyPriceClicked = void 0;
var _reduxForm = require("redux-form");
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants");
var _decimalPlacesHelper = require("../../../helpers/decimalPlaces/decimalPlacesHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _futuresOrdersSelectors = require("../selectors/futuresOrdersSelectors");
var _selectors = require("../selectors");
var _FuturesOrderEntryFormContainer = require("../../../components/OrderEntryComponents/futures/FuturesOrderEntryForm/FuturesOrderEntryFormContainer");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Create the form value selector once at module scope
var selector = (0, _reduxForm.formValueSelector)(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME);

/**
 * Action creator for when a price is clicked in the order book
 * Updates the appropriate price field based on the current order type
 * @param {string|number} price - The price that was clicked
 */
var priceClicked = exports.priceClicked = function priceClicked(_ref) {
  var price = _ref.price;
  return function (dispatch, getState) {
    var state = getState();
    if (!state.form[_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME]) return;
    var selectedOrderType = selector(state, 'orderType');
    var isConditionalOrder = selectedOrderType === _orderEntryFormConstants.futuresOrderTypes.conditional.displayName;

    // If current order type is Market, switch to Limit when price is clicked
    if (selectedOrderType === _orderEntryFormConstants.futuresOrderTypes.market.displayName) {
      dispatch((0, _reduxForm.change)(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME, 'orderType', _orderEntryFormConstants.futuresOrderTypes.limit.displayName));
    }

    // For conditional orders, update triggerPrice. For limit orders, update limitPrice
    var priceField = isConditionalOrder ? 'triggerPrice' : 'limitPrice';
    var truncatedPrice = (0, _numberFormatter.parseNumberToLocale)(price);
    dispatch((0, _reduxForm.change)(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME, priceField, truncatedPrice));
  };
};

/**
 * Action creator for when a quantity is clicked in the order book
 * Updates the quantity field and sets order type to Market
 * @param {Event} e - The click event
 * @param {boolean} isBuy - Whether this is from the buy side of the order book
 */
var quantityClicked = exports.quantityClicked = function quantityClicked(_ref2) {
  var quantity = _ref2.quantity,
    index = _ref2.index,
    _ref2$isBuy = _ref2.isBuy,
    isBuy = _ref2$isBuy === void 0 ? true : _ref2$isBuy;
  return function (dispatch, getState) {
    var state = getState();

    // Get the appropriate orders based on whether we're on buy or sell side
    var orders = isBuy ? (0, _futuresOrdersSelectors.futuresLevel2BuySelector)(state, {
      filterMode: 'selectedInstrument'
    }) : (0, _futuresOrdersSelectors.futuresLevel2SellSelector)(state, {
      filterMode: 'selectedInstrument'
    });
    var selectedInstrument = (0, _selectors.futuresSelectedInstrumentSelector)(state);
    var convertedQuantityIncrement = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.QuantityIncrement);
    var overallQuantity = calculateQuantity((0, _numberFormatter.truncateToDecimals)(quantity, convertedQuantityIncrement), orders, index, isBuy);

    // Update form with quantity and set to market order
    dispatch((0, _reduxForm.change)(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME, 'quantity', overallQuantity));
    dispatch((0, _reduxForm.change)(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME, 'orderType', _orderEntryFormConstants.futuresOrderTypes.market.displayName));

    // Clear price fields when switching to market order
    dispatch(clearField(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME, 'limitPrice', ''));
    dispatch(clearField(_FuturesOrderEntryFormContainer.FUTURES_ORDER_FORM_NAME, 'triggerPrice', ''));
  };
};

// For backwards compatibility, maintain separate named exports that use the shared handlers
var buyPriceClicked = exports.buyPriceClicked = priceClicked;
var sellPriceClicked = exports.sellPriceClicked = priceClicked;
var buyQuantityClicked = exports.buyQuantityClicked = function buyQuantityClicked(data) {
  return quantityClicked(_objectSpread(_objectSpread({}, data), {}, {
    isBuy: true
  }));
};
var sellQuantityClicked = exports.sellQuantityClicked = function sellQuantityClicked(data) {
  return quantityClicked(_objectSpread(_objectSpread({}, data), {}, {
    isBuy: false
  }));
};

// Utility to clear a form field value and untouch it
var clearField = function clearField(form, field, initialValue) {
  return function (dispatch) {
    dispatch((0, _reduxForm.change)(form, field, initialValue));
    dispatch((0, _reduxForm.untouch)(form, field));
  };
};

// Calculate the total quantity based on the order book data
var calculateQuantity = function calculateQuantity(initValue, orders, quantityIndex) {
  var buy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var init = new _bignumber["default"](initValue);
  var quantity = orders.filter(function (data, index) {
    return buy ? index < quantityIndex : index > quantityIndex;
  }).reduce(function (prev, current) {
    return prev.plus(current.Quantity);
  }, init);
  return quantity.toString();
};